<template>
  <div>
    <p v-for="line in storyLine.lines" :key="line.index" class="story-text-style">{{ line }}</p>

    <section v-if="userChoice[5] == 'leave'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateTo('sorrow')">Not Go</button>
      <button class="story-btn-style" @click="navigateTo('goal', true, 'Uno-Clan')">Go</button>
    </section>

    <section v-if="userChoice[5] == 'stay'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[5] == 'leaveToFind'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[5] == 'sorrow'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section
      v-if="userChoice[5] == 'notUnite__Clan'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[5] == 'unite__Clan'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[5] == 'findFairy'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section
      v-if="userChoice[5] == 'notUnite__Fight'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[5] == 'unite__Fight'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Seven",
  data() {
    return {
      userTrait: this.$store.state.userPersonality,
      userChoice: this.$store.state.userChoices
    };
  },
  computed: {
    storyLine() {
      return this.$store.state.Seven[this.userChoice[5]];
    }
  },
  methods: {
    navigateEnd(condition) {
      if (condition) {
        this.$router.push("/story/end");
      }
    },
    navigateTo(choice = "none", isTraitRequired = false, trait = "") {
      let checkAccess, deniedReason;
      if (isTraitRequired) {
        if (this.userTrait.indexOf(trait) > -1) {
          checkAccess = true;
          this.$store.dispatch("updateChoice", choice);
        } else {
          checkAccess = false;
          deniedReason = `You don't have the particular trait: ${trait}`;
        }
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: checkAccess,
          deniedReason,
          url: "/story/eight"
        });
      } else {
        this.$store.dispatch("updateChoice", choice);
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: true,
          url: "/story/eight"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/Scheme.scss";
</style>
